import { render } from "./ReportResetView.vue?vue&type=template&id=05b3bb06&scoped=true&ts=true"
import script from "./ReportResetView.vue?vue&type=script&lang=ts"
export * from "./ReportResetView.vue?vue&type=script&lang=ts"

import "./ReportResetView.vue?vue&type=style&index=0&id=05b3bb06&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b3bb06"]])

export default __exports__